export default "__VITE_ASSET__6b154f3a__"